<template>
  <div>
    <!--login modal-->
    <b-modal
      ref="login-modal"
      hide-footer
      hide-header
      centered
    >
      <div class="modal-block text-center">
        <h5>登入</h5>
        <div
          class="pull-right clickable"
          style="margin-top: -40px;"
          @click="close()"
        >&times;</div>
        <div class="clearfix"></div>
      </div>
      <div class="modal-block">
        <b-form @submit="LoginHandler">
          <b-form-group id="login-identity-group">
            <div class="mb-1">帳號</div>
            <b-form-input
              id="login-identity"
              v-model="login.id"
              placeholder="電子郵件或手機"
              :state="validLoginId"
            ></b-form-input>
            <b-form-invalid-feedback :state="validLoginId">請輸入信箱</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group id="login-pwd-group">
            <div class="mb-1 d-flex justify-content-between">
              <span>密碼</span>
              <small
                class="text-basic-gray align-self-end clickable"
                @click="$refs['forget-password-modal'].show()"
              >忘記密碼?</small>
            </div>
            <b-form-input
              id="login-pwd"
              type="password"
              v-model="login.pwd"
              placeholder="密碼"
              autocomplete="current-password"
              :state="validLoginPwd"
            ></b-form-input>
            <b-form-invalid-feedback :state="validLoginPwd">請輸入密碼</b-form-invalid-feedback>
          </b-form-group>
          <b-button
            class="mt-3 login-button"
            block
            type="submit"
          >登入</b-button>
        </b-form>
      </div>
      <div class="text-center text-basic-gray">
        或
      </div>
      <div class="modal-block">
        <div
          class="fb-button pull-left clickable d-flex"
          @click="FBLoginHandler"
        >
          <div><i class="fab fa-facebook-square"></i></div>
          <div class="w-100 text-center">以Facebook 登入</div>
        </div>

        <div
          id="google-signin-button"
          class="google-button pull-left clickable d-flex"
        >
          <div><img src="@/assets/images/google_icon.svg"></div>
          <div class="w-100 text-center">以Google 登入</div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="text-center small mt-3 text-basic-gray">
        還沒有帳號？ <span
          @click="openRegisterModal"
          class="signup-link clickable"
        >馬上註冊</span>
      </div>
    </b-modal>
    <!--register modal-->
    <b-modal
      ref="register-modal"
      hide-footer
      centered
      scrollable
      title="會員"
    >
      <div class="modal-block text-center">
        <h3>註冊</h3>
      </div>
      <b-form @submit="RegistHandler">
        <b-form-group
          id="regis-first-name-group"
          label="姓"
          label-for="regis-first-name"
        >
          <b-form-input
            id="regis-first-name"
            v-model="reg.first_name"
            placeholder="請輸入姓"
            :state="validRegFirstName"
            :maxlength="lastnameLengthLimit"
          ></b-form-input>
          <b-form-invalid-feedback :state="validRegFirstName">請輸入姓</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="regis-last-name-group"
          label="名字"
          label-for="regis-last-name"
        >
          <b-form-input
            id="regis-last-name"
            v-model="reg.last_name"
            placeholder="請輸入名字"
            :state="validRegLastName"
            :maxlength="nameLengthLimit"
          ></b-form-input>
          <b-form-invalid-feedback :state="validRegLastName">請輸入名字</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="regis-email-group"
          label="信箱"
          label-for="regis-email"
        >
          <b-form-input
            id="regis-email"
            v-model="reg.email"
            placeholder="請輸入信箱"
            :state="emailValidate.valid"
            :maxlength="emailLengthLimit"
            @blur="checkEmailHandler"
          ></b-form-input>
          <b-form-invalid-feedback :state="emailValidate.valid">{{emailValidate.msg}}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="regis-phone-group"
          label="手機"
          label-for="regis-phone"
        >
          <b-form-input
            id="regis-phone"
            v-model="reg.phone"
            placeholder="請輸入手機"
            :state="phoneValidate.valid"
            :maxlength="mobileLengthLimit"
            @blur="checkPhoneHandler"
            type="tel"
          ></b-form-input>
          <b-form-invalid-feedback :state="phoneValidate.valid">{{phoneValidate.msg}}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="regis-pwd-group"
          label="密碼"
          label-for="regis-pwd"
        >
          <b-form-input
            id="regis-pwd"
            type="password"
            v-model="reg.pwd"
            placeholder="請輸入密碼"
            :state="validRegPwd"
            :maxlength="pwdLengthLimit"
          ></b-form-input>
          <b-form-invalid-feedback :state="validRegPwd">請輸入5-20位的密碼，並包含英文和數字</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="regis-pwd-check-group"
          label-for="regis-pwd-check"
          description="請輸入5-20位的密碼，並包含英文和數字"
        >
          <b-form-input
            id="regis-pwd-check"
            type="password"
            v-model="reg.pwd_check"
            placeholder="請再次輸入密碼"
            :state="validRegPwdCheck"
            :maxlength="pwdLengthLimit"
          ></b-form-input>
          <b-form-invalid-feedback :state="validRegPwdCheck">請輸入相同的密碼</b-form-invalid-feedback>
        </b-form-group>
        <b-button
          class="mt-3"
          variant="red"
          block
          type="submit"
        >送出</b-button>
        <b-button
          class="mt-2"
          variant="outline-red"
          block
          @click="open"
        >返回</b-button>
      </b-form>
    </b-modal>
    <!--email verification modal-->
    <b-modal
      ref="email-verification-modal"
      hide-footer
      centered
      title="註冊成功"
    >
      <div class="d-block">
        驗證信已寄出，請收信並點選連結驗證。<br>
        沒收到驗證信？<b-button
          :disabled="emailResend.onCooldown"
          variant="red"
          @click="resendEmailHandler"
        >重新寄信</b-button><span v-if="emailResend.onCooldown">{{emailResend.coolDown}}</span>
      </div>
    </b-modal>
    <!--forget password modal-->
    <b-modal
      ref="forget-password-modal"
      hide-footer
      centered
      title="重設密碼"
    >
      <forget-password />
    </b-modal>
  </div>
</template>
<script>
import _ from 'lodash'
import forgetpassword from '@/components/ForgetPasswordBlock'

export default {
  name: 'signinmodal',
  components: {
    'forget-password': forgetpassword
  },
  data () {
    return {
      // const
      emailLengthLimit: 254,
      pwdLengthLimit: 20,
      nameLengthLimit: 30,
      lastnameLengthLimit: 24,
      mobileLengthLimit: 15,
      RECAPTCHA_TOKEN: '6LfsnbwUAAAAAF3yCtIDeDm3aY9IeKl0PtmLhOP9',
      //
      reg: {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        pwd: '',
        pwd_check: ''
      },
      login: {
        id: '',
        pwd: ''
      },
      emailValidate: {
        valid: false,
        last: '',
        msg: ''
      },
      phoneValidate: {
        valid: false,
        last: '',
        msg: ''
      },
      validate: false,
      emailResend: {
        onCooldown: false,
        coolDown: 0
      },
      googleAuth2: null
    }
  },
  created () {
    this.setupFBLogin()
    // register events
    this.$eventHub.$on('open-login-modal', (data) => {
      if (!this.$store.getters['account/IS_LOGIN']) {
        this.open()
      }
    })
  },
  mounted () {
  },
  beforeDestroy () {
    // unregister events
    this.$eventHub.$off('open-login-modal')
  },
  methods: {
    open: async function () {
      this.initialize()
      await Promise.all([this.$refs['login-modal'].show(), this.$refs['register-modal'].hide()])
      this.setupGoogleLogin()
    }, // 開啟登入視窗
    close: function () {
      this.$refs['login-modal'].hide()
      this.$refs['register-modal'].hide()
    }, // 關閉視窗
    setupFBLogin () {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: '506276429918889',
          cookie: true,
          xfbml: true,
          version: 'v5.0'
        })
        window.FB.AppEvents.logPageView()
      };
      (function (d, s, id) {
        let js
        let fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) { return }
        js = d.createElement(s); js.id = id
        js.src = 'https://connect.facebook.net/en_US/sdk.js'
        fjs.parentNode.insertBefore(js, fjs)
      }(document, 'script', 'facebook-jssdk'))
    },
    setupGoogleLogin () {
      let _vue = this
      window.gapi.load('auth2', function () {
        _vue.googleAuth2 = window.gapi.auth2.init({
          client_id: '976238878737-9dd8koanem6u1117vrjr50e9st6vhhb8.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin'
        })
        _vue.googleAuth2.attachClickHandler(document.getElementById('google-signin-button'), {},
          _vue.onGoogleLogin, function (error) {
            console.log(error)
          })
      })
    },
    initialize () {
      this.reg = {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        pwd: '',
        pwd_check: ''
      }
      this.login = {
        id: '',
        pwd: ''
      }
      this.validate = false
    }, // 初始化
    regisProcess: _.debounce((() => {
      let _processing = false
      return async function () {
        let _vue = this
        let _data = {
          name: _vue.reg.first_name + _vue.reg.last_name,
          password: _vue.reg.pwd,
          email: _vue.reg.email,
          phone: _vue.reg.phone
        }
        if (!_processing) {
          _processing = true
          try {
            let token = await _vue.getRecaptchaToken()
            if (token) {
              _data.token = token
              let result = await _vue.doRegis(_data)
              if (!result) {
                this.makeToast('錯誤', '註冊失敗')
              }
            } else {
              this.makeToast('驗證失敗', '請稍後重新嘗試')
            }
          } catch (error) {
            console.log(error)
          } finally {
            _processing = false
          }
        }
      }
    })(), 100), // 註冊流程
    loginProcess: _.debounce((() => {
      let _processing = false
      return async function () {
        let _vue = this
        let _data = {
          email: _vue.login.id,
          password: _vue.login.pwd
        }
        if (!_processing) {
          _processing = true
          try {
            let token = await _vue.getRecaptchaToken()
            if (token) {
              _data.token = token
              let result = await _vue.doLogin(_data)
              if (!result) {
                this.makeToast('登入失敗', '帳號或密碼錯誤')
              }
            } else {
              this.makeToast('驗證失敗', '請稍後重新嘗試')
            }
          } catch (error) {
            console.log(error)
          } finally {
            _processing = false
          }
        }
      }
    })(), 100), // 登入流程
    getRecaptchaToken: async function () {
      return 'token'
      // return new Promise((resolve) => {
      //   window.grecaptcha.ready(async () => {
      //     let token = await window.grecaptcha.execute(this.RECAPTCHA_TOKEN)
      //     console.log(token)
      //     resolve(token)
      //   })
      // })
    }, // 取得Recaptcha
    doRegis: async function (data) {
      try {
        let response = await this.$http.post('/api/Account/SignUp', data)
        if (response.data.token) {
          this.$refs['register-modal'].hide()
          this.$refs['email-verification-modal'].show()
          this.$store.dispatch('account/LOGIN', response.data)
          this.$eventHub.$emit('setup-customer-noti')
          return response.data
        }
      } catch (error) {
        console.log(error)
      }
      return null
    }, // 註冊
    doLogin: async function (data) {
      try {
        let response = await this.$http.post('/api/Account/Login', data)
        if (response.data.token) {
          this.$refs['login-modal'].hide()
          this.$store.dispatch('account/LOGIN', response.data)
          this.$eventHub.$emit('setup-customer-noti')
          return response.data
        }
      } catch (error) {
        console.log(error)
      }
      return null
    }, // 登入
    doResendEmail: async function (data) {
      return this.$http.post('/api/Account/Email/Verify', data).then(response => {
        console.log(response.data)
      })
    }, // 重寄驗證信
    onFBLogin (token) {
      let _vue = this
      return _vue.$http.post('/api/Account/FacebookLogin?token=' + token).then(response => {
        if (response.data.token) {
          console.log('onFBLogin', JSON.parse(JSON.stringify(response.data)))
          _vue.$refs['login-modal'].hide()
          return _vue.$store.dispatch('account/LOGIN', response.data)
        } else {
          this.makeToast('登入失敗', '帳號或密碼錯誤')
        }
      }, err => {
        console.log(err)
      })
    }, // FBLogin
    onGoogleLogin (googleUser) {
      let _vue = this
      if (googleUser) {
        var token = googleUser.getAuthResponse(true).access_token
        return _vue.$http.post('/api/Account/GoogleLogin?token=' + token).then(response => {
          console.log('onGoogleLogin', JSON.parse(JSON.stringify(response.data)))
          _vue.$refs['login-modal'].hide()
          return _vue.$store.dispatch('account/LOGIN', response.data)
        }, err => {
          return Promise.reject(err)
        })
      }
    }, // Google
    checkEmail (data) {
      return this.$http.get('/api/Users/Emails/' + data + '/exists')
    },
    checkPhone (data) {
      return this.$http.get('/api/Users/Phone/' + data + '/exists')
    },
    cooldownHandler () {
      setTimeout(() => {
        this.emailResend.coolDown--
        if (this.emailResend.coolDown <= 0) {
          this.emailResend.onCooldown = false
        } else {
          this.cooldownHandler()
        }
      }, 1000)
    },
    checkEmailHandler () {
      let _email = this.reg.email
      if (this.emailValidate.last !== _email) {
        if (this.validRegEmailFormat) {
          this.emailValidate.valid = null
          this.checkEmail(_email).then(response => {
            console.log(response)
            this.emailValidate.valid = !response.data.result
            this.emailValidate.last = _email
            if (!this.emailValidate.valid) {
              this.emailValidate.msg = '信箱已被使用'
            }
          }, error => {
            console.log(error)
          })
        }
      }
    },
    checkPhoneHandler () {
      let _phone = this.reg.phone
      if (this.phoneValidate.last !== _phone) {
        if (this.validRegPhoneFormat) {
          this.phoneValidate.valid = null
          this.phoneValidate.last = _phone
          this.checkPhone(_phone).then(response => {
            this.phoneValidate.valid = !response.data.result
            this.phoneValidate.last = _phone
            if (!this.phoneValidate.valid) {
              this.phoneValidate.msg = '電話號碼已被使用'
            }
          }, error => {
            console.log(error)
          })
        }
      }
    },
    RegistHandler (evt) {
      evt.preventDefault()
      this.validate = true
      if (this.validRegFirstName &&
        this.validRegLastName &&
        this.emailValidate.valid && this.phoneValidate.valid &&
        this.validRegPwd &&
        this.validRegPwdCheck) {
        this.regisProcess()
      }
    }, // 註冊事件處理
    LoginHandler (evt) {
      evt.preventDefault()
      this.validate = true
      if (this.validLogin) {
        this.loginProcess()
      }
    }, // 登入事件處理
    submitForgetPwdHandler () {
      this.$refs['forget-password-modal'].hide()
    }, // 忘記密碼事件處理
    resendEmailHandler () {
      if (!this.emailResend.onCooldown) {
        this.emailResend.onCooldown = true
        this.emailResend.coolDown = 15
        this.cooldownHandler()
        this.doResendEmail()
      }
    }, // 重寄驗證信事件處理(need debounce)
    FBLoginHandler () {
      let _vue = this
      let _fbTokenLogin = function (token) {
        return _vue.onFBLogin(token)
      }
      let _fblogin = function () {
        window.FB.login(function (response) {
          console.log('FB.login', response)
          if (response.authResponse) {
            _fbTokenLogin(response.authResponse.accessToken)
          }
        }, {
          scope: 'email, public_profile',
          return_scopes: true
        })
      }
      return window.FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
          console.log('FB.getLoginStatus', response)
          return _fbTokenLogin(response.authResponse.accessToken)
        } else {
          return _fblogin()
        }
      })
    }, // FB登入事件處理(need debounce)
    openRegisterModal () {
      this.initialize()
      this.$refs['login-modal'].hide()
      this.$refs['register-modal'].show()
    }, // 開啟註冊視窗
    makeToast (title, msg, delay = 3000, append = true) {
      this.$bvToast.toast(msg, {
        title: title,
        autoHideDelay: delay
      })
    } // 顯示訊息視窗
  },
  computed: {
    validRegEmailFormat () {
      let _regex = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
      return (!this.validate && this.reg.email.length === 0) ? null : this.reg.email.match(_regex) !== null
    },
    validRegPhoneFormat () {
      let _regex = /^[0-9+]+$/
      return (!this.validate && this.reg.phone.length === 0) ? null : this.reg.phone.match(_regex) !== null
    },
    validRegFirstName () {
      return (!this.validate && this.reg.first_name.length === 0) ? null : (this.reg.first_name.length > 0)
    },
    validRegLastName () {
      return (!this.validate && this.reg.last_name.length === 0) ? null : (this.reg.last_name.length > 0)
    },
    validRegPwd () {
      return (!this.validate && this.reg.pwd.length === 0) ? null : (this.reg.pwd.length >= 5 && this.reg.pwd.length <= this.pwdLengthLimit)
    },
    validRegPwdCheck () {
      return (!this.validate && this.reg.pwd_check.length === 0) ? null : (this.reg.pwd_check.length > 0 && this.reg.pwd_check === this.reg.pwd)
    },
    validLoginId () {
      return !this.validate ? null : this.login.id.length > 0 ? null : false
    },
    validLoginPwd () {
      return !this.validate ? null : this.login.pwd.length > 0 ? null : false
    },
    validLogin () {
      return this.login.id.length > 0 && this.login.pwd.length > 0
    }
  },
  watch: {
    validRegEmailFormat: {
      immediate: true,
      handler (value) {
        if (value === false) {
          this.emailValidate.valid = false
          this.emailValidate.msg = '請輸入正確的email格式'
        } else {
          this.emailValidate.valid = null
          this.emailValidate.last = ''
        }
      }
    },
    validRegPhoneFormat: {
      immediate: true,
      handler (value) {
        if (value === false) {
          this.phoneValidate.valid = false
          this.phoneValidate.msg = '請輸入手機號碼'
        } else {
          this.phoneValidate.valid = null
          this.phoneValidate.last = ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.modal-block {
  display: block;
  margin: 5px auto;
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #d1d1d1;
    opacity: 1; /* Firefox */
  }

  h5 {
    color: $papayum_red;
  }
  input {
    border-radius: 10px;
  }
  button {
    border-radius: 10px;
  }
}
.signup-link {
  color: $papayum_red;
}
.login-button {
  background-color: $papayum_red;
  border: none;
}
.fb-button {
  background-color: #3b559f;
  width: calc(50% - 0.25rem);
  padding: 0.3rem;
  margin-right: 0.5rem;
  border-radius: 10px;
  color: $basic-white;
  font-size: 0.7rem;
  i {
    font-size: 1rem;
    margin-right: 0.2rem;
  }
}
.google-button {
  background-color: $basic-white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
  width: calc(50% - 0.25rem);
  padding: 0.3rem;
  font-size: 0.7rem;
  img {
    width: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer/SignInModal.vue